import { Abteilung } from '@/domain/arbeitszeiten/entities';
import { markierungMapper } from '@/utils';

export function getColorByOption(
  abteilungId: string,
  abteilungen: Abteilung[],
) {
  const abteilung = abteilungen.find((a) => a.id.toLowerCase() === abteilungId);
  if (!abteilung) {
    return null;
  }
  const color = markierungMapper[abteilung.markierung].base;
  return color;
}
